import {
    Box,
    Flex,
    Heading,
} from "@chakra-ui/react";
import { RolesTable } from "../../components/roles-table/roles-table.comp";

export function RolesList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Roles</Heading>
            </Flex>
            <RolesTable />
        </Box>
    );
}
